module.exports = __webpack_public_path__ + "static/logo-6da5d4f6f3aaf0e2bfcb6d01fc070a12.png";